import { AsideInfo, IInitializeWizardCompanyData, InitializedWizardCompanyData } from './interface'
import { asideInfoByStep } from './constants'
import {
  EFileClassification,
  EFileFormat,
  EFileType,
  EPersonType,
  filesTypesOfficialID,
  WIZARD_STAGES_ID,
  WIZARD_STAGES_SEQUENCE
} from 'utils/constants'
import { IFileTypes } from './components/Documents/interface'
import { TFunction } from 'i18next'

export const getAsideInfo = (t: TFunction, currentStep: string): AsideInfo => {
  return asideInfoByStep(t)[currentStep] || asideInfoByStep(t)[WIZARD_STAGES_ID.evaluation]
}

const getFilesTypesCustom = (documentId: string, fileTypes: IFileTypes): IFileTypes => {
  if (documentId === EFileClassification.officialIDFront || documentId === EFileClassification.officialIDBack) {
    return filesTypesOfficialID
  }

  return fileTypes
}

export const getFileTypes = (id: string, fileTypes: IFileTypes): IFileTypes => {
  return id === EFileClassification.PROOF_OF_TAX_IDENTIFICATION
    ? { [EFileType.PDF]: [`.${EFileFormat.PDF}`] }
    : getFilesTypesCustom(id, fileTypes)
}

export const validateFields = (
  t: TFunction,
  values: Record<string, string>,
  fieldValidations: Record<string, string>,
  errors: Record<string, string>,
  errorsLabel: string
): Record<string, string> => {
  Object.entries(fieldValidations).forEach(([key, value]) => {
    if (!values[key]) {
      errors[key] = t(`${errorsLabel}.${value}`)
    }
  })
  return errors
}

export const initializeWizardCompanyData = ({
  activations,
  documents,
  entity,
  mcc,
  wizardData
}: IInitializeWizardCompanyData): InitializedWizardCompanyData => {
  const STAGES_WITHOUT_EVAL = [...entity.stages]
  const EVALUATION_STAGE_INDEX = STAGES_WITHOUT_EVAL.findIndex(
    ({ statusName }: { statusName: string }) => statusName === WIZARD_STAGES_ID.evaluation
  )
  const commercialName =
    entity.fiscalInfo.fiscalType === EPersonType.PHYSICAL ? entity.name : entity.fiscalInfo.legalName

  const getStageOnPlateId = (): number => {
    const ID_WITHOUT_EVALUATION = STAGES_WITHOUT_EVAL.length - 1
    const ID_STAGE_SEQUENCE = WIZARD_STAGES_SEQUENCE.findIndex(
      stage => stage === STAGES_WITHOUT_EVAL[ID_WITHOUT_EVALUATION]?.statusName
    )

    return ID_STAGE_SEQUENCE <= 0 ? 0 : ID_STAGE_SEQUENCE
  }

  STAGES_WITHOUT_EVAL.splice(EVALUATION_STAGE_INDEX, 1)

  return {
    ...wizardData,
    documents: [...documents],
    commercialInfo: {
      ...entity.commercialInfo,
      commercialName
    },
    clabe: entity.externalAccounts[0]?.reference,
    entityId: entity.id,
    fiscalInfo: entity.fiscalInfo,
    hasData: true,
    idReferenceCompany: entity.idReferenceCompany,
    legalInfo: { legalRepresentativeName: entity.legalInfo?.legalRepresentativeName },
    mcc: mcc.code,
    name: entity.name,
    planSelected: entity.level,
    riskLevel: mcc.riskLevel.toLowerCase(),
    signatureType: mcc?.signatureTypes?.[0]?.signature ?? '',
    stageOnPlate: {
      id: getStageOnPlateId(),
      name: WIZARD_STAGES_SEQUENCE[getStageOnPlateId()]
    },
    stages: STAGES_WITHOUT_EVAL
  }
}
